export default "__VITE_ASSET__B5oxev5E__"